import { Grid } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useContext } from "react";
import { LocaleContext } from "../../../routing/LangRouter";

//import constants
import { IS_MOBILE } from "../../../constants/breakpoints";
import { ItineraryContext } from "../../../constants/layouts/itinerary-layout";

//import general components
import BaseTitle from "../../common/base-title/base-title";
import EmptyOrErrorState from "../../common/empty-or-error-state/empty-or-error-state";
import HotelSkeleton from "./hotel-skeleton";

//import view components
import HotelItem from "./hotel-item";

//import images and icons
import { InfoCircle } from "iconsax-react";

function IntHotelList({ hotelList, loading, type }) {
    //general variables
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { locale } = useContext(LocaleContext);
    const { routes, setRoutes } = useContext(ItineraryContext);

    //sessionStorage variables
    const { isItinerary } = JSON.parse(sessionStorage.getItem("generalInformation"));

    //skip to the itinerary page
    const skipLevel = () => {
        setRoutes([...routes, `/${locale}/itinerary/itinerary-page`]);
        sessionStorage.setItem("visitedRoutes", JSON.stringify([...routes, `/${locale}/itinerary/itinerary-page`]));
        navigate(`/${locale}/itinerary/itinerary-page`);
    };

    return (
        <Grid container item xs={12} rowGap={2} justifyContent="center">
            {loading ? <HotelSkeleton /> : !IS_MOBILE && <BaseTitle title={type === "hotel" ? `${t("hotelList")}` : `${t("accommodationList")}`} dividerColor="1px solid var(--medium-gray-color)" />}

            {hotelList?.length && !loading
                ? hotelList?.map(hotelItem => {
                      return <HotelItem key={hotelItem?.id} hotelItem={hotelItem} />;
                  })
                : !loading && (
                      <EmptyOrErrorState
                          title={t("hotelListMessage")}
                          icon={<InfoCircle size="32" color="var(--secondary-color)" variant="Bold" />}
                          actionLabel={isItinerary ? t("nextLevel") : ""}
                          handleClick={isItinerary ? skipLevel : null}
                      />
                  )}
        </Grid>
    );
}

export default IntHotelList;
